module.exports = __webpack_public_path__ + "img/preview_desc.7cf004cb.png";